import { Modal } from 'components/common';
import React from 'react';
import OmniChannelChatHistoriesFilterForm from './OmniChannelChatHistoriesFilterForm';
import OmniChannelChatHistoriesSectionList from './OmniChannelChatHistoriesSessionList';
import { OmniHistoriesManageProvider, useOmniHistoriesManageContext } from 'contexts';
import OmniChannelChatHistoriesChatBox from './OmniChannelChatHistoriesChatBox';

type Props = {
  onCancel?: () => void;
  open?: boolean;
};

const OmniChannelChatHistoriesModal: React.FC<Props> = ({ open, onCancel }) => {
  const { chatSession } = useOmniHistoriesManageContext();

  return (
    <Modal
      styles={{
        body: { padding: 0 }
      }}
      width={1336}
      open={open}
      onCancel={onCancel}
      centered
      maskClosable={false}
      destroyOnClose
      footer={null}
      title='Lịch sử chat'
    >
      <div className='relative flex h-[calc(100vh-260px)] overflow-hidden rounded-b-[10px]'>
        <div className='flex max-h-[calc(100vh-260px)] w-[400px] overflow-auto rounded-tl-[10px] bg-[#F5F3F6]'>
          <OmniChannelChatHistoriesFilterForm />
        </div>
        <div className='h-ful relative flex max-h-full flex-1 overflow-hidden bg-white'>
          {/* Phiên chat */}
          {!chatSession && <OmniChannelChatHistoriesSectionList />}

          {/* Hộp chat */}
          {chatSession && <OmniChannelChatHistoriesChatBox chatSession={chatSession} />}
        </div>
      </div>
    </Modal>
  );
};

const OmniChannelChatHistoriesModalContent = (props: Props) => {
  if (!props.open) return null;
  return (
    <OmniHistoriesManageProvider>
      <OmniChannelChatHistoriesModal {...props} />
    </OmniHistoriesManageProvider>
  );
};

export default OmniChannelChatHistoriesModalContent;
